import { useRef /* , useEffect */ } from 'react';
import Atropos from 'atropos/react';
import styles from './KeyVisual.module.scss';

const KeyVisual = (/* { setLoading } */) => {
  const videoRef = useRef(null);

  // useEffect(() => {
  //   const video = videoRef.current;
  //   video.addEventListener('progress', function() {
  //     let buffered = 0;
  //     let seekable = 0;
  //     for (let i = 0; i < video.buffered.length; i++) {
  //       buffered += video.buffered.end(i);
  //       seekable += video.seekable.end(i);
  //     }
  //     const progress = (Math.round(buffered) / Math.round(seekable)) || 0;
  //     setLoading(progress);
  //   });
  // }, [videoRef]);

  return (
    <Atropos
      eventsEl="#root"
      className={ styles.atropos }
      shadow={ false }
      highlight={ false }
      activeOffset={ 1 }
      rotateXMax={ 5 }
      rotateYMax={ 5 }
    >
      <div className={ styles.container }>
        <video ref={ videoRef } autoPlay loop muted playsInline preload="auto">
          <source 
            src={ `${process.env.PUBLIC_URL}/videos/kv.mov` }
            type='video/mp4; codecs="hvc1"'
          />
          <source 
            src={ `${process.env.PUBLIC_URL}/videos/kv.webm` }
            type="video/webm"
          />
        </video>
      </div>
    </Atropos>
  );
};

export default KeyVisual;